import React from 'react';
import Loadable from 'react-loadable';
import SidebarBlank from './../../components/Common/SidebarBlank';
import LeftBlankContent from './../../components/Common/LeftBlankContent';

const ProductLoadable = Loadable({
    loader: () => import('./Product' /* webpackChunkName: 'product' */).then(module => module.default),
    loading: () => (<div>
        <LeftBlankContent />
        <SidebarBlank />
    </div>)
});

export default ProductLoadable;
